import React from "react";
import "./DocumentNumberField.css";

const ICONS = {
  error: "fas fa-triangle-exclamation",
  warning: "fas fa-circle-exclamation",
  success: "fas fa-circle-check",
  info: "fas fa-circle-info",
};

/**
 * Text input for invoice / offer numbers with live duplicate detection.
 * The analysis itself lives in utils/documentNumbers.js.
 */
const DocumentNumberField = ({
  label,
  value,
  onChange,
  onApplySuggestion,
  analysis,
  placeholder,
  required = false,
}) => {
  const severity = analysis?.severity || "idle";
  const hasStatus = severity !== "idle" && !!analysis?.message;
  const suggestion = analysis?.suggestion;
  const isEmpty = !String(value || "").trim();

  return (
    <div className="offer-maker__form-group doc-number">
      <label className="offer-maker__label">
        {label} {required && <span className="doc-number__required">*</span>}
      </label>
      <input
        type="text"
        className={`offer-maker__input doc-number__input doc-number__input--${severity}`}
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        required={required}
        autoComplete="off"
        spellCheck={false}
      />

      {hasStatus && (
        <div className={`doc-number__status doc-number__status--${severity}`}>
          <i className={ICONS[severity]} aria-hidden="true"></i>
          <span className="doc-number__message">
            {analysis.message}
            {analysis.notation && (
              <span className="doc-number__notation">
                Existing numbers are written as {analysis.notation.expected}.
              </span>
            )}
          </span>
        </div>
      )}

      {suggestion && (
        <button
          type="button"
          className="doc-number__suggestion"
          onClick={() => onApplySuggestion(suggestion)}
        >
          <i className="fas fa-wand-magic-sparkles" aria-hidden="true"></i>
          {isEmpty ? "Use next number" : "Use"} {suggestion}
        </button>
      )}
    </div>
  );
};

export default DocumentNumberField;
